import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

const PageContainer = ({ Page, ThemeName }) => {
  const [themeapplied, setThemeapplied] = useState(ThemeName);

  const handleThemeChange = (theme) => {
    setThemeapplied(theme);
    if (theme === 'light') {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    } else {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    }
  };

  return (
    <div className="bg-slate-200 dark:bg-slate-900 h-screen">
      <div className="homecolor-box" />
      {(themeapplied === 'dark')
        ? (
          <button type="button" onClick={() => handleThemeChange('light')} className="fixed custom-position">
            <FontAwesomeIcon icon={faSun} />
          </button>
        ) : (
          <button type="button" onClick={() => handleThemeChange('dark')} className="fixed custom-position">
            <FontAwesomeIcon className="text-white" icon={faMoon} />
          </button>
        ) }
      <Page />
    </div>
  );
};

PageContainer.propTypes = {
  Page: PropTypes.func.isRequired,
  ThemeName: PropTypes.string.isRequired,
};

export default PageContainer;
